import { Reducer } from 'redux';
import { SchemasState, SchemasTypes } from './types';

const INITIAL_STATE: SchemasState = {
  schemasList: {
    $schema: '',
    description: '',
    type: '',
    oneOf: [],
  },
  error: false,
  loading: false,
};

const reducer: Reducer<SchemasState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST_SCHEMA
    case SchemasTypes.LIST_SCHEMA_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        schemasList: INITIAL_STATE.schemasList,
      };
    case SchemasTypes.LIST_SCHEMA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schemasList: action.payload.schemasList,
      };
    case SchemasTypes.LIST_SCHEMA_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        schemasList: INITIAL_STATE.schemasList,
      };
    default:
      return state;
  }
};

export default reducer;
